import { takeLatest, takeEvery } from 'redux-saga/effects';

import { buildFilterQuery, fetchSaga, removeSaga, saveSaga } from './helper';
import { post, put } from '../../utils/request';

import {
  fetchEmployeesRoutine,
  fetchEmployeeRoutine,
  saveEmployeeRoutine,
  removeEmployeeRoutine,
} from '../routines';

import { getAccountPath } from '../../utils/firebase';

function* watchFetchEmployeesSaga() {
  yield takeLatest(fetchEmployeesRoutine.TRIGGER, fetchSaga(fetchEmployeesRoutine, (payload) => getAccountPath('employees') + '?' + buildFilterQuery(payload) ));
}

function* watchFetchEmployeeSaga() {
  yield takeLatest(fetchEmployeeRoutine.TRIGGER, fetchSaga(fetchEmployeeRoutine, (payload) => getAccountPath('employees',payload.id)));
}

function* watchSaveEmployeeSaga() {
  yield takeLatest(saveEmployeeRoutine.TRIGGER, saveSaga(
    saveEmployeeRoutine,
    (payload) => getAccountPath('employees', payload.values.get('id')),
    (payload) => payload.values.get('id') ? put : post,
    (payload) => payload.values));
}

function* watchRemoveEmployeeSaga() {
  yield takeEvery(removeEmployeeRoutine.TRIGGER, removeSaga(removeEmployeeRoutine, (payload) => getAccountPath('employees',payload.id)));
}

export {
  watchFetchEmployeesSaga,
  watchFetchEmployeeSaga,
  watchSaveEmployeeSaga,
  watchRemoveEmployeeSaga,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/employees.js